{
  "blocks": [
    {
      "id": "program-his-optimization",
      "kind": "program",
      "tags": ["optimization", "his", "sperm", "supplements", "lifestyle"],
      "title": "His 90-Day Optimization",
      "subtitle": "Measurably improve sperm health: real numbers, real progress",
      "icon": "🏋️",
      "body": {
        "duration": "3 months",
        "includes": [
          "Baseline semen analysis with detailed morphology",
          "Targeted supplement stack (CoQ10, Zinc, Vitamin D, Omega-3)",
          "Lifestyle protocol (heat avoidance, exercise, sleep, alcohol)",
          "Monthly check-ins with progress tracking",
          "Repeat semen analysis at 90 days",
          "Optional: DNA fragmentation panel"
        ],
        "priceRange": {
          "low": 300,
          "high": 600
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "him",
        "category": "optimization",
        "moduleIds": [
          "module-male-fertility-baseline",
          "module-male-optimization"
        ],
        "phases": [
          {
            "title": "Baseline",
            "description": "Semen analysis to know your starting numbers",
            "moduleIds": ["module-male-fertility-baseline"]
          },
          {
            "title": "Optimize",
            "description": "90 days targeting the full sperm cycle",
            "moduleIds": ["module-male-optimization"]
          }
        ],
        "steps": [
          {
            "title": "Baseline SA",
            "description": "Semen analysis to establish count, motility, and morphology."
          },
          {
            "title": "Begin protocol",
            "description": "Supplements and lifestyle changes targeting the 74-day sperm development cycle."
          },
          {
            "title": "Retest at 90 days",
            "description": "Repeat semen analysis to measure improvement in count, motility, and morphology."
          }
        ]
      },
      "sources": [
        {
          "title": "The effect of antioxidant supplementation on sperm parameters: a systematic review",
          "journal": "Reproductive BioMedicine Online",
          "year": 2022,
          "evidenceLevel": "meta-analysis"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-his-optimization",
      "to": "module-male-fertility-baseline",
      "type": "contains"
    },
    {
      "from": "program-his-optimization",
      "to": "module-male-optimization",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
